import { User } from "@/js/User.js";
import { Logger } from "@/js/utils/Logger.js";

/**
 * チケットコードの照会を行う共通ロジック
 * @param {Object} param0
 * @param {String} param0.code 照会するコード
 * @param {Object} param0.store Vuex store（acrylicTicketCouponManagerを参照）
 * @returns {Promise<Object|null>} 見つからない/権限外の場合はnull
 */
export async function lookupTicketCode({ code, store }) {
  const manager = store.state.acrylicTicketCouponManager;
  const codeData = await manager.getTicketData(code);
  if (!codeData) {
    return null;
  }

  const result = {
    code,
    isUsed: codeData.isUsed,
    usedAt: codeData.isUsed ? codeData.usedAt.toDate() : null,
    validFrom: codeData.validFrom.toDate(),
    validTo: codeData.validTo.toDate(),
    orderId: null,
    orderStatus: null,
  };

  if (codeData.isUsed) {
    const orderId = await manager.getTicketUsedOrderId(code);
    result.orderId = orderId;
    if (orderId) {
      try {
        const orderData = await User.orderStatus(orderId);
        result.orderStatus = orderData.status_name;
      } catch (error) {
        Logger.error(error);
        throw error;
      }
    }
  }

  return result;
}
